module.exports = __webpack_public_path__ + "public/img/sold.902f2c3c.svg";